import { render, staticRenderFns } from "./saleShip.vue?vue&type=template&id=d3cb33de&scoped=true&"
import script from "./saleShip.vue?vue&type=script&lang=js&"
export * from "./saleShip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3cb33de",
  null
  
)

export default component.exports